import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {RunNovaAgentDryRunInput, RunNovaAgentDryRunMutation} from './__generated__/RunNovaAgentDryRunMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// A dry run: the agent is run against a real task and the answer is returned to the author, with
// nothing written back to the task. The answer itself is not held in the Relay store — a dry run's
// output is one answer the Test tab keeps in component state until the author navigates away.
//
// `run` is the saved record, read back after the write. `threadId` is selected because a follow-up
// has to carry it back for the model to be replayed its own prior turns; nothing derives a thread
// from the agent and task alone. Taking it off the record rather than from memory is what makes the
// id the next turn sends one the record can actually be replayed from. That record does normalise
// into the store — it has a stable id and is a real, saved row, unlike the answer beside it.
const mutation = graphql`
	mutation RunNovaAgentDryRunMutation($input: RunNovaAgentDryRunInput!) {
		runNovaAgentDryRun(input: $input) {
			result {
				output
				ranAt
				run {
					threadId
					modelDisplayName
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RunNovaAgentDryRunInput>,
	onSuccess?: RelayOnCompleted<RunNovaAgentDryRunMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RunNovaAgentDryRunMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
